import React, { useId } from "react";
import { cn } from "@/helpers/utils";
import { Button, ButtonTypedButtonProps } from "@/components/Button";

export interface ToggleButtonProps extends ButtonTypedButtonProps {
  className?: string;
  href?: string;
  label: React.ReactNode;
  selected: boolean;
  clear?: () => void;
  name: string;
}

export const ToggleButton = ({
  label,
  selected,
  onClick,
  size = "md",
  clear,
  name,
  id: idProp,
  className,
  ...rest
}: ToggleButtonProps) => {
  const backupId = useId();
  const id = idProp ?? backupId;
  return (
    <Button
      {...rest}
      id={id}
      role="radio"
      aria-checked={selected}
      size={size}
      name={name}
      variant="outline"
      className={cn(
        "flex-1 border-0 bg-transparent px-1 font-normal normal-case tracking-normal text-gray-700 ring-1 ring-gray-700 aria-checked:font-bold aria-checked:text-primary aria-checked:ring-2 aria-checked:ring-primary",
        className
      )}
      onClick={selected ? clear ?? onClick : onClick}
    >
      {label}
    </Button>
  );
};
